import { ReactNode } from 'react';
import HighlightedIconCircle from './HighlightedIconCircle';

const FeatureItem = ({
  iconContent,
  title,
  description,
  alignment = 'center',
  color = 'blue',
}: {
  iconContent: ReactNode;
  title: string;
  description: string;
  alignment?: 'left' | 'center';
  color?: Parameters<typeof HighlightedIconCircle>[0]['color'];
}) => {
  return (
    <div
      className={`flex flex-col ${alignment === 'center' ? 'items-center text-center' : 'flex-start text-left'}`}
    >
      <HighlightedIconCircle color={color}>{iconContent}</HighlightedIconCircle>
      <div className='mt-4 sm:mt-5 text-gray-800 text-xl font-semibold'>{title}</div>
      <div className='mt-1 sm:mt-2 text-gray-500'>{description}</div>
    </div>
  );
};

export default FeatureItem;
